import React, { useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { size, isEmpty } from "lodash";
import { ListLayout } from '../containers/Layout';

import { Button, TableRow, TableCell, TableHead, Box, TableBody, IconButton, Typography, CircularProgress } from '@material-ui/core';
import { AddRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import { useFetchTransfers } from '../../../../../../../jsx/hooks/getTransfers';
import { fetchTransferDetails } from '../../../../../../../jsx/actions/transferAction';
import Currency from '../../../../commonModules/Currency';

const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

const ListPurchaseItem = (props) => {
    const dispatch = useDispatch();
    const PURCHASES = useSelector((state) => state.inventory.purchases.PURCHASES); 
    const fetchTransfersPurchases = useFetchTransfers(props.dataview);

    const [state,setState] = useState({ 
    })
    const [purchaseList,setPurchaseList] =useState([[], 0])
    const [purchaseDetails, setPurchaseDetails] = useState({})
    const [loading, setLoading] = useState(false)
    
    useEffect(() => {
        if (isEmpty(PURCHASES)){
            fetchTransfersPurchases()
        }
    }, []);

    // Fetch detailed products for filtered purchases
    useEffect(() => {
        const fetchPurchaseProducts = async () => {
            if (isEmpty(PURCHASES)) return;
            
            setLoading(true)
            const { PURCHASES: PURCHASES_PROP } = props;
            let purchaseList = !isEmpty(PURCHASES_PROP) ? Object.values(PURCHASES_PROP) : []
            let filteredPurchases = props.getFilteredList(purchaseList)
            
            // Fetch products for each purchase that we don't have yet
            const detailsMap = {...purchaseDetails}
            const fetchPromises = []
            
            for (const purchase of filteredPurchases) {
                if (!detailsMap[purchase.id]) {
                    fetchPromises.push(
                        dispatch(fetchTransferDetails(purchase.id))
                            .then(details => {
                                detailsMap[purchase.id] = details
                            })
                            .catch(err => {
                                console.error(`Failed to fetch details for purchase ${purchase.id}:`, err)
                            })
                    )
                }
            }
            
            await Promise.all(fetchPromises)
            setPurchaseDetails(detailsMap)
            setLoading(false)
        }
        
        fetchPurchaseProducts()
    }, [props.PURCHASES, props.selectShop, props.received, props.searchFacture, props.searchType, props.start_date, props.end_date]);

    useEffect(() => {
        let purchaseListTmp = displayList()
        setPurchaseList(purchaseListTmp)
    }, [purchaseDetails, props.searchProduct, props.currentPageProd, props.rowsPerPage]);



    const createPurchaseList = (list) =>{ 
        const { PURCHASES, SHOPS, PRODUCTS, rowsPerPage, currentPageProd } = props

        return list.slice(currentPageProd * rowsPerPage, currentPageProd * rowsPerPage + rowsPerPage).map(prod => {

            let purchase = PURCHASES[prod.purchase_id]
            if(purchase){
                let shop = SHOPS[prod.purchase_item_shop]
                
                // Calculate unit price: total_ht / quantity
                const unitPrice = prod.total_ht && prod.quantity 
                    ? parseFloat(prod.total_ht) / parseFloat(prod.quantity) 
                    : 0
                
                return (
                    <TableRow key={prod.id || prod.product_id}>
                        <TableCell>{(new Date(prod.purchase_item_date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>{PRODUCTS[prod.product_id]?.name} - {PRODUCTS[prod.product_id]?.marque}</TableCell>
                        <TableCell>{prod.quantity}</TableCell>
                        <TableCell><Currency value={unitPrice} /></TableCell>
                        <TableCell>
                            <a href="#" onClick={
                                () => props.handleSingleShop(shop)
                                }> {shop?.name}
                            </a>
                        </TableCell>
                        <TableCell>
                            <IconButton color="secondary" onClick={
                                () => props.handleSinglePurchase(purchase, shop)
                            }>
                                <AddRounded />
                            </IconButton>
                        </TableCell>                                
                    </TableRow>
                )
                
            }
            return null          
        })
    }

    const filterAll = () => {
        const { searchProduct, PURCHASES } = props;

        // Convert PURCHASES object to array and pass to getFilteredList
        let purchaseList = !isEmpty(PURCHASES) ? Object.values(PURCHASES) : []
        let newList = props.getFilteredList(purchaseList)
        
        // Extract items from fetched purchase details
        let itemList = []
        newList.forEach(purchase => {
            const details = purchaseDetails[purchase.id]
            if (details && details.products && Array.isArray(details.products)) {
                // Add purchase_id and other metadata to each item
                const itemsWithMeta = details.products.map(item => ({
                    ...item,
                    purchase_id: purchase.id,
                    purchase_item_shop: purchase.shop_id,
                    purchase_item_date: purchase.creation_date
                }))
                itemList.push(...itemsWithMeta)
            }
        })
        
        if( !isEmpty(searchProduct)){
            itemList = itemList.filter(item => props.prodFilter(item.product_id))
        }
        return itemList
    }
    const displayList = () => {
        const { PURCHASES } = props;
        let tab = []
        let rows = 0
        
        if (!isEmpty(PURCHASES)){
            let filteredList = filterAll()
            rows = size(filteredList)
            tab = createPurchaseList(filteredList)
        }
        return [tab, rows]
    }
        return (
            <Box>
                <Box p={1}>
                    <Typography variant="h6">Liste des produits achetés</Typography>
                    {loading && <CircularProgress size={20} style={{marginLeft: 10}} />}
                </Box>
                <ListLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            <TableCell>Prix</TableCell>
                            <TableCell>Shop</TableCell>
                            <TableCell>Détails</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { loading && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    <CircularProgress />
                                    <Typography variant="body2">Chargement des produits...</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        { !loading && purchaseList[1] !== 0 && 
                            purchaseList[0]
                        }
                        { !loading && purchaseList[1] === 0 && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    <Typography variant="body2">Aucun produit trouvé</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    { 
                        <TableFooterPagination 
                            colSpan={6}
                            // items={purchaseList[0]} 
                            count={purchaseList[1]}
                            onChangePage={props.onChangePage}
                            initialPage={props.currentPageProd || 0}
                            page={props.currentPageProd}
                        />         
                    }  
                </ListLayout>                     
            </Box>
        );
}

export default ListPurchaseItem;